// This module should be used if you want to setup control
// logic that runs a block of code only on the server or
// only on the client.
export default typeof window === 'undefined';
